import React from 'react';
import { NextSeo } from 'next-seo';
import * as PropTypes from 'prop-types';
import Head from 'next/head';
import { Link } from '../../router';
import Layout from '../layout/Layout';
import { classes, classNamer } from '../../lib/utils';
import Details from '../widgets/Details';
import R from '../../lib/routes';
import ReactMarkdown from '../widgets/ReactMarkdown';
import BlogArticleShare from './BlogArticleShare';
import { dateDisplay, createFrontendPageUrl, resolveStrapiImage } from '../../lib/selectors';
import Navigation from '../widgets/Navigation';
import ProgressiveLoadingImage from '../widgets/ProgressiveLoadingImage';
import i18n from '../../translations/i18n';
const cn = classNamer('BlogArticlePage');

import './BlogArticlePage.scss';

const ArticleContainer = ({ children, className }) => {
  return (
    <div className={classes('container', className)}>
      <div className="row justify-content-center">
        <div className="col">{children}</div>
      </div>
    </div>
  );
};

class BlogArticlePage extends React.PureComponent {
  render() {
    const { article, next, prev, ...passProps } = this.props;

    const topArticleNavigation = (
      <Navigation prev={prev} next={next} dynamicRoute={R.blogArticle}>
        <Link href={R.blog}>
          <a>{i18n.allArticles}</a>
        </Link>
      </Navigation>
    );

    return (
      <>
        <Head>
          <meta name="description" content={article.summary} key="description" />
          <title>{article.title}</title>
        </Head>
        <NextSeo
          openGraph={{
            url: createFrontendPageUrl(R.blogArticle(article)),
            locale: 'en_US',
            title: article.title,
            type: 'article',
            article: { published_at: dateDisplay(article.published_at) },
            description: article.summary,
            images: [resolveStrapiImage(article.preview_image)],
            site_name: i18n.blogpageSiteName,
          }}
          twitter={{
            site: 'tradexcalibra',
            cardType: 'summary_large_image',
          }}
        />
        <Layout
          title={article.title}
          className={`${cn()}`}
          {...passProps}
          currentPageComponent={topArticleNavigation}
        >
          <ArticleContainer className="Article">
            <div className={cn('outer-wrapper')}>
              <div className={cn('navigation', 'top')}>{topArticleNavigation}</div>
              <div className={cn('inner-wrapper')}>
                <div className={cn('article-head')}>
                  <div className={cn('article')}>
                    <h1 className={cn('title')}>{article.title}</h1>
                  </div>
                  <Details item={article} />

                  {article.preview_image && (
                    <ProgressiveLoadingImage
                      className={classes(cn('preview-image'))}
                      image={article.preview_image}
                    />
                  )}
                </div>

                <div className={cn('article-body')}>
                  <BlogArticleShare article={article} className={cn('share')} />
                  <div className={cn('content')}>
                    <ReactMarkdown source={article.content} />
                  </div>
                </div>
              </div>
              <div className={cn('navigation', 'bottom')}>
                <Navigation prev={prev} next={next} dynamicRoute={R.blogArticle}>
                  <a href="#top" title="Back to top">
                    {i18n.backToTop}
                  </a>
                </Navigation>
              </div>
            </div>
          </ArticleContainer>
        </Layout>
      </>
    );
  }
}

BlogArticlePage.propTypes = {
  article: PropTypes.object,
  next: PropTypes.object,
  prev: PropTypes.object,
};

export default BlogArticlePage;
